import React, { useCallback, useEffect, useRef, useState } from "react";
import { jumpTo } from "components";
import { collectFunc } from "components";
import "./index.less";
import Loading from "./loading";
import message from "components/message";
import { usePag } from "containers/pagProvider";

function HomePage({
  setShowTransitionPag,
  showTransitionPag,
  setShowHomePage,
  handleDirectShowMap,
  isAlreadySeen,
  isLoading,
  setIsLoading,
  isLogin,
  getDataError,
  setPlayer,
}) {
  const t = window.t;

  let bottomBtnText = t("Start my journey");
  let eventBtnName = "clicktoland";
  let goToLogin = false;

  if (!isLogin) {
    bottomBtnText = t("Login to start");
    eventBtnName = "logintostart";
    goToLogin = true;
  } else if (isAlreadySeen) {
    bottomBtnText = t("Start a new journey");
    eventBtnName = "restartjourney";
  }
  const isDirectToMap = useRef(false);
  // transferPag
  const { pag, homepagePag, touristMapPag, setPagFail, pagFail } = usePag();
  const [jumpFlag, setJumpFlag] = useState(false);

  useEffect(() => {
    async function generateBg() {
      try {
        // const pagFile = await pag.PAGFile.load(homepagePag);
        const pagFile = homepagePag;
        const canvas = document.getElementById("homepageImg");
        // canvas.style.opacity = 0;
        canvas.width = pagFile.width();
        // canvas.width = window.screen.width;
        canvas.height = pagFile.height();
        // 实例化 PAGView 对象
        pag.PAGView.init(pagFile, canvas, {
          firstFrame: false,
        }).then(
          async (pagView) => {
            // // 播放 PAGView
            pagView.setRepeatCount(0);
            pagView.setScaleMode(2);
            // const matrix = new pag.Matrix();
            const originMatrix = pagView.matrix();
            Object.assign(originMatrix, { ty: 0 });
            pagFile.setMatrix(originMatrix);
            // canvas.style.opacity = 1;
            // document.querySelector(".homepage-pag-wrapper").style.display = "none";
            await pagView.play();
            setJumpFlag(true);
          },
          (err) => {
            // setIsLoading(false);
            setJumpFlag(true);
          },
        );
        // const pagView = await pag.PAGView.init(pagFile, canvas, {
        //   firstFrame: true,
        // });
        // // 播放 PAGView
        // pagView.setRepeatCount(0);
        // pagView.setScaleMode(3);
        // // const matrix = new pag.Matrix();
        // const originMatrix = pagView.matrix();
        // Object.assign(originMatrix, { ty: 0 });
        // pagFile.setMatrix(originMatrix);
        // canvas.style.opacity = 1;
        // document.querySelector(".homepage-pag-wrapper").style.display = "none";
        // await pagView.play();
        // 防止真机读材质问题
      } catch (e) {
        // message({
        //   type: "noIcon",
        //   content: "homepage generate pag failed!",
        //   isHomePage: true,
        // });
        setTimeout(() => {
          // console.error(e);
          setJumpFlag(true);
          setPagFail(true);
        }, 300);
      }
    }

    // transferPag
    if (pag && homepagePag && touristMapPag && !pagFail) {
      generateBg();
    } else if (pagFail) {
      setJumpFlag(true);
    }
  }, [pag, homepagePag, setIsLoading, touristMapPag, setPagFail, pagFail]);

  const handleClick = () => {
    if (goToLogin) {
      // 跳转登录，需区分安卓与ios端
      if (!window.$$device_type) {
        jumpTo({ link: "/login", name: "_self" });
      } else {
        if (window.$$device_type == 1) {
          window.gateio.startLogin();
        } else {
          window.webkit.messageHandlers.startLogin.postMessage(null);
        }
      }
    } else if (getDataError) {
      message({
        type: "noIcon",
        content: t("Load failed, please try again!"),
        isHomePage: true,
      });
      window.location.reload();
      return;
    } else {
      if (!jumpFlag) {
        setIsLoading(true);
        return;
      } else {
        // document.querySelector(".transition_container").style.zIndex = 1;
        // document.querySelector(".homepage-pag-wrapper").style.display = "none";

        // showTransitionImg(); // 去掉首页底部按钮
        setShowTransitionPag(true); // 开启转场动画
        setShowHomePage(false);
        // 播放音乐
        if (isLogin) {
          document.getElementById("player").play();
          isLogin && setPlayer(true);
        }
        collectFunc({
          eventName: "annualbill_openingpage_button_click",
          params: { button_name: eventBtnName },
        });
      }
    }
  };

  // 去掉首页底部按钮
  const showTransitionImg = useCallback(() => {
    // 计时器等待动画结束
    setTimeout(() => {
      const bottomBtn = document.querySelector(".home-page-bottom-block");
      bottomBtn.style.display = "none";
    }, 3000);
  }, []);

  const handeDirectAchievement = () => {
    if (getDataError) {
      message({
        type: "noIcon",
        content: t("Load failed, please try again!"),
        isHomePage: true,
      });
      window.location.reload();
      return;
    }

    if (!jumpFlag) {
      isDirectToMap.current = true;
      setIsLoading(true);
      return;
    } else {
      if (isLogin) {
        document.getElementById("player").play();
        isLogin && setPlayer(true);
      }
      document.querySelector("#homepageImg").style.zIndex = 11;
      // document.querySelector(".homepage-pag-wrapper").style.display = "none";

      setShowHomePage(false);
      handleDirectShowMap();
      // setShowTransitionPag(true);
      collectFunc({
        eventName: "annualbill_openingpage_button_click",
        params: { button_name: "openingpageachievementshare" },
      });
    }
  };

  useEffect(() => {
    if (jumpFlag && isLoading) {
      setIsLoading(false);
      isDirectToMap.current ? handeDirectAchievement() : handleClick();
    }
  }, [jumpFlag, isLoading]); // eslint-disable-line

  return (
    <div className={`home-page HomePage`}>
      <Loading showLoading={isLoading} />
      <div
        className={`welcome-text WorldBookDayQuestionOne__textWrap  ${showTransitionPag ? "addAnimation" : ""
          }`}
      >
        <p className="bounce-in-top welcome-text-line1  fw-700">
          {" "}
          {t("Welcome")}
        </p>
        <p className="welcome-text-line2 bounce-in-top-delay">
          {" "}
          {t("Subtitle")}
        </p>
      </div>
      {/* <div className="homepage-pag-wrapper"></div> */}
      <canvas id="homepageImg"></canvas>
      {/* <video preload="auto" playsInline id="homepageVideo" loop autoPlay>
        <source src={homepage} type="video/mp4" />
      </video> */}
      <div
        className={`home-page-bottom-block ${showTransitionPag ? "addAnimation" : ""
          }`}
      >
        {!isLogin && (
          <div className={`bottom-btn fw-700`} onClick={handleClick}>
            <div>{bottomBtnText}</div>
          </div>
        )}

        {isLogin && isAlreadySeen !== undefined && (
          <div
            className={`bottom-btn fw-700 ${isAlreadySeen && 'already-btn'}`}
            onClick={handleClick}
          >
            <div>{bottomBtnText}</div>
          </div>
        )}

        {isLogin && isAlreadySeen && (
          <div
            className="bottom-btn fw-700 achievement already-btn"
            onClick={() => {
              handeDirectAchievement();
            }}
          >
            <div>{t("View My Achievements")}</div>
          </div>
        )}
        <div className="home-page-bottom-tips">
          {t("Data as of", { dateString: "2023/12/13" })}
        </div>
      </div>
    </div>
  );
}

export default HomePage;
